export default {
  downloadFormat: {
    CM10: 'CM10',
    pdf: 'Fichero PDF',
    copy: 'Copia del original firmada digitalmente',
    ubl: 'UBL 1.0',
    facturae_3_2: 'Facturae 3.2',
    facturae_3_2_1: 'Facturae 3.2.1',
    facturae_3_2_2: 'Facturae 3.2.2',
    owner: 'Formato propietario'
  },
  acceptedBills: 'Las facturas fueron aceptadas con éxito.',
  rejectedBills: 'Las facturas fueron rechazadas con éxito.',
  unrejectedBills: 'Las facturas fueron des-rechazadas con éxito.',
  cancelledBills: 'Las solicitudes de anulación de las facturas fueron realizadas con éxito.',
  acceptedCancel: 'La anulación de las facturas fueron aceptadas con éxito.',
  rejectedCancel: 'La anulación de las facturas fueron rechazadas con éxito.',
  sentBills: 'Las facturas fueron enviadas con éxito.',
  deletedBills: 'Las facturas fueron eliminadas con éxito.',
  financingSuccessed: 'Su proceso de solicitud de financiación se ha iniciado correctamente.'
}
